import React from 'react';

import { BottomBarWrapper, Wrapper } from './styles';

const BottomBar = () => (
  <Wrapper>
    <BottomBarWrapper>{this.props.children}</BottomBarWrapper>
  </Wrapper>
);

export default BottomBar;
